import { Enums } from '@bode-canada/core';
import headMeta from '@/constants/headMeta';
import routes from '@/constants/routes';
import ListingMixin from './listing';
import ListingMetaHelper from './helpers/ListingMetaHelper';

const ListingHeadMixin = {
  mixins: [ListingMixin],
  head() {
    return this.headOG;
  },
  computed: {
    headOG() {
      return {
        title: this.pageTitle,
        meta: [
          { hid: 'description', name: 'description', content: this.pageDescription },
          { property: 'og:title', content: this.pageTitle },
          { property: 'og:description', content: this.pageDescription },
          { property: 'og:url', content: `${headMeta.domain}${routes.listings}/${this.$route.params.id}` },
          { property: 'og:site_name', content: headMeta.siteName },
          { property: 'og:type', content: headMeta.type },
          { property: 'og:image', content: this.pageImage },
        ],
      };
    },
    pageTitle() {
      const prefix = this.listing.isBode
        ? ListingMetaHelper.BODE_TITLE_PREFIX
        : ListingMetaHelper.MLS_TITLE_PREFIX;

      return ListingMetaHelper.getPageTitle(this.listing, prefix);
    },
    pageDescription() {
      return ListingMetaHelper.buildDescription([
        ListingMetaHelper.PAGE_INTRODUCTION,
        ListingMetaHelper.getPropertyDescription(this.listing.buildingClass),
        ListingMetaHelper.getCommunityAndCityDescription(this.listing),
        ListingMetaHelper.getListingSizeDescription(this.listing, this.listing.formattedPrice),
        this.fullAddressDescription,
        this.bookViewingDescription,
      ]);
    },
    pageImage() {
      return ListingMetaHelper.getMainImage(this.listing);
    },
    fullAddressDescription() {
      const propertyClass = this.listing.buildingType === Enums.BuildingTypeEnum.VACANT_LAND
        ? 'Vacant land'
        : 'Home';

      return `${propertyClass} for sale: ${this.listing.fullAddress}.`;
    },
    bookViewingDescription() {
      return this.listing.isBode
        ? 'Book a viewing directly with the seller.'
        : 'Book a viewing yourself.';
    },
  },
};

export default ListingHeadMixin;
